export default "__VITE_ASSET__BOoJNsl6__"